<template>
  <div>
    <app-header id="header"></app-header>
    <div id="content">

      <div class="container">
        <div class="row">
          <div class="col-12 p-2">

            <div class="box-dark">
              <h6 class="font-weight-bold">Karte</h6>
              <GmapMap class="box-dark"
                       id="gmap"
                       :center="{lat: 46.658409, lng: 11.575184}"
                       :zoom="14">
                <GmapMarker :position="{lat: 46.658420, lng: 11.575126}" :clickable="true" :draggable="false"/>
              </GmapMap>

            </div>

          </div>

          <div class="col-12 p-2">

            <div class="box-dark">

              <h6 class="font-weight-bold">Adresse</h6>
              <p>
                <pin-icon/>
                Verdings 25 | 39043 Klausen
              </p>

              <h6 class="font-weight-bold">E-Mail</h6>

              <p>
                <mail-icon/>
                automanuel(at)gmail(dot)com
              </p>

              <h6 class="font-weight-bold">Telefon</h6>

              <p>
                <call-icon/>
                0472 855 459
              </p>

              <h6 class="font-weight-bold">Handy</h6>

              <p>
                <phone-portrait-icon/>
                +39 346 660 7551
              </p>

            </div>

          </div>

          <!--<div class="col-12 col-md-6 p-2">-->

            <!--<div class="box-dark">-->

              <!--<h6 class="font-weight-bold">Nachricht</h6>-->

              <!--<form @submit="e.preventDefault()">-->

                <!--<div class="form-group">-->
                  <!--<label for="email">E-Mail *</label>-->
                  <!--<input id="email" type="email" name="name" class="form-control"-->
                         <!--placeholder="Bitte E-Mail eingeben" required="required"-->
                         <!--data-error="Dieses Feld wird benötigt.">-->
                  <!--<div class="help-block with-errors"></div>-->
                <!--</div>-->

                <!--<div class="form-group">-->
                  <!--<label for="name">Name *</label>-->
                  <!--<input id="name" type="text" name="name" class="form-control"-->
                         <!--placeholder="Bitte Namen eingeben" required="required"-->
                         <!--data-error="Dieses Feld wird benötigt.">-->
                  <!--<div class="help-block with-errors"></div>-->
                <!--</div>-->

                <!--<div class="form-group">-->
                  <!--<label for="text">Nachricht *</label>-->
                  <!--<textarea id="text" name="name" class="form-control"-->
                            <!--placeholder="Text" required="required"-->
                            <!--data-error="Dieses Feld wird benötigt."></textarea>-->
                  <!--<div class="help-block with-errors"></div>-->
                <!--</div>-->

                <!--<div class="text-right">-->
                  <!--<input type="submit" class="btn btn-outline-success btn-send" value="Nachricht senden">-->
                <!--</div>-->
              <!--</form>-->
            <!--</div>-->
          <!--</div>-->
        </div>
      </div>

      <app-footer id="footer"></app-footer>
    </div>
  </div>
</template>

<script>
  import AppHeader from '@/components/AppHeader'
  import AppFooter from '@/components/AppFooter'
  import CallIcon from 'vue-ionicons/dist/md-call'
  import PhonePortraitIcon from 'vue-ionicons/dist/md-phone-portrait'
  import PinIcon from 'vue-ionicons/dist/md-pin'
  import MailIcon from 'vue-ionicons/dist/md-mail'

  export default {
    name: 'Index',
    components: {
      AppFooter,
      AppHeader,
      CallIcon,
      PhonePortraitIcon,
      PinIcon,
      MailIcon,
    },
    data() {
      return {}
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../styles/variables';
  @import '../styles/custom';

  #gmap {
    width: 100%;
    height: 60vh;
  }

  .box-dark {
    background: darken(#343a40, 5%);
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2),
    0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
    transition: box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 0.25rem;
    padding: 2rem;
  }

  .form-control {
    color: #fff;
    background-color: darken(#343a40, 2.5%);
    border-color: darken(#343a40, 6%);
  }
</style>
